import * as i0 from '@angular/core';
import { Component, Inject, Injectable, forwardRef, EventEmitter, Directive, Optional, Input, Output, NgModule } from '@angular/core';
import { filter, tap, map, switchMap } from 'rxjs/operators';
import { Subject, of, merge, fromEvent } from 'rxjs';
import * as i1$3 from '@angular/cdk/overlay';
import { OverlayModule } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import * as i1 from '@angular/common';
import { DOCUMENT, CommonModule } from '@angular/common';
import * as i1$1 from '@am/moebius';
import { MbIconModule } from '@am/moebius';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import * as i2 from '@angular/cdk/layout';
import * as i1$2 from '@angular/common/http';

window.dataLayer = window.dataLayer || [];
const analyticsEvent = (eventCategory, eventAction, eventLabel = null, eventValue = null) => {
    window.dataLayer.push({
        event: "trackEvent",
        eventCategory,
        eventAction,
        eventLabel,
        eventValue
    });
};

const ANALYTICS_CATEGORY = "analytics-category-token";

class DestinationDialogComponent {
    constructor(analyticsCategory) {
        this.analyticsCategory = analyticsCategory;
        this.valueSelected$ = new Subject();
    }
    ngOnInit() {
    }
    selectDestination(entity) {
        analyticsEvent(this.analyticsCategory, 'Click suggestions destination', `${entity.label}`);
        this.valueSelected$.next(entity);
    }
    originalOrder() {
        return 0;
    }
}
/** @nocollapse */ DestinationDialogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DestinationDialogComponent, deps: [{ token: ANALYTICS_CATEGORY }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ DestinationDialogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: DestinationDialogComponent, selector: "am-destination-dialog", ngImport: i0, template: "<div data-au=\"destination-dialog\" class=\"destination-dialog\" *ngIf=\"suggestion\">\n  <div class=\"triangle\"></div>\n  <ng-container *ngFor=\"let item of suggestion | keyvalue: originalOrder; let first = first\">\n    <div\n      attr.data-au=\"{{item.key}}\"\n      [ngClass]=\"{ 'other': !first }\"\n      class=\"destination-dialog__group\"\n      *ngIf=\"item.value.length > 0\"\n    >\n      <ng-container [ngSwitch]=\"item.key\">\n        <div *ngIf=\"item.value.length > 0\" class=\"destination-dialog__title\">\n          <ng-container *ngSwitchCase=\"'searches'\">\n            <ng-container\n              *ngTemplateOutlet=\"searches; context: { $implicit: item }\"\n            ></ng-container>\n          </ng-container>\n          <ng-container *ngSwitchCase=\"'recommendations'\">\n            <ng-container\n              *ngTemplateOutlet=\"recommendations; context: { $implicit: item }\"\n            ></ng-container>\n          </ng-container>\n        </div>\n      </ng-container>\n      <ul data-au=\"destination-list\" class=\"destination-dialog__list\" *ngIf=\"item.value.length > 0\">\n        <li\n          data-au=\"destination-item\"\n          class=\"destination-dialog__item\"\n          *ngFor=\"let entity of item.value\"\n        >\n          <a class=\"destination-dialog__item-link\" (click)=\"selectDestination(entity)\">{{\n            entity.label\n          }}</a>\n        </li>\n      </ul>\n    </div>\n  </ng-container>\n</div>\n<ng-template #searches let-item>\n  <mb-icon class=\"destination-dialog__title-icon\" icon=\"DestinationDialog:search\"></mb-icon>\n  <p\n    class=\"destination-dialog__title-text\"\n    i18n=\"@@destinationDialog-searchesTitle\"\n  >\n    B\u00FAsquedas recientes\n  </p>\n</ng-template>\n<ng-template #recommendations let-item>\n  <mb-icon class=\"destination-dialog__title-icon\" icon=\"DestinationDialog:pin-star\"></mb-icon>\n  <p\n    class=\"destination-dialog__title-text\"\n    i18n=\"@@destinationDialog-recommendationsTitle\"\n  >\n    Destinos populares\n  </p>\n</ng-template>\n", styles: [".destination-dialog{background-color:var(--color-white);border:solid 1px var(--color-gray);border-radius:4px;display:flex;flex-direction:column;margin:8px 0;padding:20px}.destination-dialog .triangle{border-bottom:7px solid var(--color-gray);border-left:12px solid transparent;border-right:12px solid transparent;height:0;left:5px;position:absolute;top:2px;width:0}.destination-dialog .triangle:before{border-bottom:6px solid var(--color-white);border-left:10px solid transparent;border-right:10px solid transparent;content:\"\";height:0;left:-10px;position:absolute;top:1px;width:0}.destination-dialog__group{display:flex;flex-direction:column;min-width:250px}.destination-dialog__group.other{margin-left:0;margin-top:10px}@media only screen and (min-width: 1152px){.destination-dialog__group.other{margin-left:15px;margin-top:0}}.destination-dialog__title{align-items:center;border-bottom:1px solid var(--color-gray);display:flex;line-height:1.25;padding-bottom:5px}.destination-dialog__title-icon{color:var(--color-secondary);font-size:1.2rem;line-height:0;margin-right:3px}.destination-dialog__title-text{color:var(--color-gray-900);margin:0;font-size:1rem;font-weight:var(--font-weight-semibold);line-height:1.5}@media only screen and (max-width: 767px){.destination-dialog__title-text{line-height:1.5}}.destination-dialog__list{list-style-type:none;margin:0;padding:10px 22px 0}.destination-dialog__item{font-size:1rem;font-weight:var(--font-weight-regular);line-height:1.5}@media only screen and (max-width: 767px){.destination-dialog__item{line-height:1.5}}.destination-dialog__item-link{color:var(--color-gray-800);cursor:pointer}@media only screen and (min-width: 1152px){.destination-dialog{flex-direction:row}}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "component", type: i1$1.MbIcon, selector: "mb-icon", inputs: ["icon", "horizontalFlip", "verticalFlip", "spin"] }, { kind: "pipe", type: i1.KeyValuePipe, name: "keyvalue" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DestinationDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'am-destination-dialog', template: "<div data-au=\"destination-dialog\" class=\"destination-dialog\" *ngIf=\"suggestion\">\n  <div class=\"triangle\"></div>\n  <ng-container *ngFor=\"let item of suggestion | keyvalue: originalOrder; let first = first\">\n    <div\n      attr.data-au=\"{{item.key}}\"\n      [ngClass]=\"{ 'other': !first }\"\n      class=\"destination-dialog__group\"\n      *ngIf=\"item.value.length > 0\"\n    >\n      <ng-container [ngSwitch]=\"item.key\">\n        <div *ngIf=\"item.value.length > 0\" class=\"destination-dialog__title\">\n          <ng-container *ngSwitchCase=\"'searches'\">\n            <ng-container\n              *ngTemplateOutlet=\"searches; context: { $implicit: item }\"\n            ></ng-container>\n          </ng-container>\n          <ng-container *ngSwitchCase=\"'recommendations'\">\n            <ng-container\n              *ngTemplateOutlet=\"recommendations; context: { $implicit: item }\"\n            ></ng-container>\n          </ng-container>\n        </div>\n      </ng-container>\n      <ul data-au=\"destination-list\" class=\"destination-dialog__list\" *ngIf=\"item.value.length > 0\">\n        <li\n          data-au=\"destination-item\"\n          class=\"destination-dialog__item\"\n          *ngFor=\"let entity of item.value\"\n        >\n          <a class=\"destination-dialog__item-link\" (click)=\"selectDestination(entity)\">{{\n            entity.label\n          }}</a>\n        </li>\n      </ul>\n    </div>\n  </ng-container>\n</div>\n<ng-template #searches let-item>\n  <mb-icon class=\"destination-dialog__title-icon\" icon=\"DestinationDialog:search\"></mb-icon>\n  <p\n    class=\"destination-dialog__title-text\"\n    i18n=\"@@destinationDialog-searchesTitle\"\n  >\n    B\u00FAsquedas recientes\n  </p>\n</ng-template>\n<ng-template #recommendations let-item>\n  <mb-icon class=\"destination-dialog__title-icon\" icon=\"DestinationDialog:pin-star\"></mb-icon>\n  <p\n    class=\"destination-dialog__title-text\"\n    i18n=\"@@destinationDialog-recommendationsTitle\"\n  >\n    Destinos populares\n  </p>\n</ng-template>\n", styles: [".destination-dialog{background-color:var(--color-white);border:solid 1px var(--color-gray);border-radius:4px;display:flex;flex-direction:column;margin:8px 0;padding:20px}.destination-dialog .triangle{border-bottom:7px solid var(--color-gray);border-left:12px solid transparent;border-right:12px solid transparent;height:0;left:5px;position:absolute;top:2px;width:0}.destination-dialog .triangle:before{border-bottom:6px solid var(--color-white);border-left:10px solid transparent;border-right:10px solid transparent;content:\"\";height:0;left:-10px;position:absolute;top:1px;width:0}.destination-dialog__group{display:flex;flex-direction:column;min-width:250px}.destination-dialog__group.other{margin-left:0;margin-top:10px}@media only screen and (min-width: 1152px){.destination-dialog__group.other{margin-left:15px;margin-top:0}}.destination-dialog__title{align-items:center;border-bottom:1px solid var(--color-gray);display:flex;line-height:1.25;padding-bottom:5px}.destination-dialog__title-icon{color:var(--color-secondary);font-size:1.2rem;line-height:0;margin-right:3px}.destination-dialog__title-text{color:var(--color-gray-900);margin:0;font-size:1rem;font-weight:var(--font-weight-semibold);line-height:1.5}@media only screen and (max-width: 767px){.destination-dialog__title-text{line-height:1.5}}.destination-dialog__list{list-style-type:none;margin:0;padding:10px 22px 0}.destination-dialog__item{font-size:1rem;font-weight:var(--font-weight-regular);line-height:1.5}@media only screen and (max-width: 767px){.destination-dialog__item{line-height:1.5}}.destination-dialog__item-link{color:var(--color-gray-800);cursor:pointer}@media only screen and (min-width: 1152px){.destination-dialog{flex-direction:row}}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [ANALYTICS_CATEGORY]
                }] }]; } });

const NATIONAL_LIST = {
    "recommendations": [
        {
            "name": "San Carlos de Bariloche",
            "code": "BRC",
            "iata": "BRC",
            "id": 1282012,
            "group": "city",
            "label": "San Carlos de Bariloche"
        },
        {
            "name": "Puerto Iguazú",
            "code": "IGR",
            "iata": "IGR",
            "id": 1304467,
            "group": "city",
            "label": "Puerto Iguazú"
        },
        {
            "name": "Ushuaia",
            "code": "USH",
            "iata": "USH",
            "id": 1347732,
            "group": "city",
            "label": "Ushuaia"
        },
        {
            "name": "Buenos Aires",
            "code": "BUE",
            "iata": "BUE",
            "id": 1282466,
            "group": "city",
            "label": "Buenos Aires"
        },
        {
            "name": "El Calafate",
            "code": "FTE",
            "iata": "FTE",
            "id": 1296027,
            "group": "city",
            "label": "El Calafate"
        },
        {
            "name": "Mendoza",
            "code": "MDZ",
            "iata": "MDZ",
            "id": 1317979,
            "group": "city",
            "label": "Mendoza"
        },
        {
            "name": "Mar del Plata",
            "code": "MDQ",
            "iata": "MDQ",
            "id": 1317933,
            "group": "city",
            "label": "Mar del Plata"
        },
        {
            "name": "Villa Gesell",
            "code": "VLG",
            "iata": "VLG",
            "id": 1350346,
            "group": "city",
            "label": "Villa Gesell"
        },
        {
            "name": "San Martín de los Andes",
            "code": "CPC",
            "iata": "CPC",
            "id": 1285603,
            "group": "city",
            "label": "San Martín de los Andes"
        },
        {
            "name": "Salta",
            "code": "SLA",
            "iata": "SLA",
            "id": 1339523,
            "group": "city",
            "label": "Salta"
        },
        {
            "name": "Córdoba",
            "code": "COR",
            "iata": "COR",
            "id": 1285525,
            "group": "city",
            "label": "Córdoba"
        }
    ],
    "searches": []
};

class DestinationDialogService {
    constructor(http) {
        this.http = http;
    }
    loadSuggestion(urlDna, product, internationalAllowed) {
        if (internationalAllowed) {
            urlDna += `?product=${product}`;
            return this.http.get(urlDna);
        }
        else {
            return of(NATIONAL_LIST);
        }
    }
}
/** @nocollapse */ DestinationDialogService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DestinationDialogService, deps: [{ token: i1$2.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ DestinationDialogService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DestinationDialogService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DestinationDialogService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$2.HttpClient }]; } });

const AM_DESTINATION_DIALOG_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => DestinationDialogDirective),
    multi: true
};
class DestinationDialogDirective {
    constructor(overlay, breakpointObserver, destinationDialogService, _document) {
        this.overlay = overlay;
        this.breakpointObserver = breakpointObserver;
        this.destinationDialogService = destinationDialogService;
        this._document = _document;
        this.hasFocus = false;
        this.canOpenDialog = true;
        this.openDialog = false;
        this.destinationSelected = new EventEmitter();
    }
    ngOnInit() {
        this.setInputSubscriptionKeyUp();
        this.setBreakpointIsOpenDialog();
        this.setUpOutsideClickSubscription();
    }
    setUpOutsideClickSubscription() {
        this.outputSideClick = merge(fromEvent(this._document, 'click'), fromEvent(this._document, 'touchend')).pipe(filter(event => {
            const clickTarget = event.target;
            return (clickTarget !== this.positionRelativeTo &&
                this._isElementOutsideOverlay(clickTarget));
        }), tap(() => (this.hasFocus = false)), tap(() => this.close())).subscribe();
    }
    _isElementOutsideOverlay(element) {
        if (!this.overlayDialog) {
            // double check for border case
            return this._document.contains(element);
        }
        else {
            return !this.overlayDialog.overlayElement.contains(element);
        }
    }
    setInputSubscriptionKeyUp() {
        this.dialogOpenKeyUp = merge(fromEvent(this.positionRelativeTo, "keyup"), fromEvent(this.positionRelativeTo, "click"))
            .pipe(map(e => {
            return e.target.value;
        }), filter((e) => e.length == 0), tap(() => (this.hasFocus = true)), switchMap(() => {
            let context = window._app_context;
            let internationalAllowed = context?.destinations?.international;
            return this.destinationDialogService.loadSuggestion(this.urlDna, this.product, internationalAllowed);
        }), filter(() => this.hasFocus))
            .subscribe((suggestion) => {
            if (this.isValidSuggestions(suggestion))
                this.open(suggestion);
        });
        this.inputFocus = fromEvent(this.positionRelativeTo, 'keydown')
            .pipe(filter(({ code }) => code === 'Tab'), tap(() => (this.hasFocus = false)), tap(() => this.close()))
            .subscribe();
        this.dialogClosedKeyUp = fromEvent(this.positionRelativeTo, "keyup")
            .pipe(map(e => {
            return e.target.value;
        }), filter((e) => e.length > 0), tap(() => (this.hasFocus = false)), tap(() => this.close()))
            .subscribe();
    }
    setBreakpointIsOpenDialog() {
        this.breakpointOpenDialog = this.breakpointObserver
            .observe(["(min-width: 1152px)"])
            .subscribe(result => {
            this.canOpenDialog = result.matches;
        });
    }
    ngOnDestroy() {
        this.dialogOpenKeyUp && this.dialogOpenKeyUp.unsubscribe();
        this.dialogClosedKeyUp && this.dialogClosedKeyUp.unsubscribe();
        this.breakpointOpenDialog && this.breakpointOpenDialog.unsubscribe();
        this.outputSideClick && this.outputSideClick.unsubscribe();
        this.inputFocus && this.inputFocus.unsubscribe();
    }
    open(suggestion) {
        if (this.canOpenDialog && !this.openDialog) {
            const positionStrategy = this.getPositionStrategy();
            this.overlayDialog = this.overlay.create({
                positionStrategy,
                scrollStrategy: this.overlay.scrollStrategies.reposition(),
                backdropClass: "am-overlay-destination-dialog-backdrop",
                hasBackdrop: true
            });
            this.overlayDialog
                .backdropClick()
                .subscribe(() => {
                this.close();
            });
            this.dialogPortal = new ComponentPortal(DestinationDialogComponent);
            const filterDestination = (destination) => !this.isSameEntity(destination, this.origin);
            const dialog = this.dialogPortal.attach(this.overlayDialog);
            const recommendations = suggestion.recommendations.filter(filterDestination);
            const searches = suggestion.searches.filter(filterDestination);
            dialog.instance.suggestion = { searches, recommendations };
            dialog.instance.valueSelected$.subscribe((select) => {
                this.destinationSelected.emit(select);
                this.close();
            });
            this.openDialog = true;
        }
    }
    isSameEntity(a, b) {
        return a && b && b.iata == b.iata && a.id == b.id;
    }
    getPositionStrategy() {
        return this.overlay
            .position()
            .flexibleConnectedTo(this.positionRelativeTo)
            .withLockedPosition()
            .withFlexibleDimensions(false)
            .withPositions([
            {
                originX: 'start',
                originY: 'bottom',
                overlayX: 'start',
                overlayY: 'top',
            },
        ]);
    }
    isValidSuggestions(suggestion) {
        return (suggestion.recommendations.length > 0 ||
            suggestion.searches.length > 0);
    }
    close() {
        if (this.overlayDialog &&
            this.overlayDialog.hasAttached()) {
            this.overlayDialog.detach();
            this.overlayDialog = null;
        }
        if (this.dialogPortal &&
            this.dialogPortal.isAttached) {
            this.dialogPortal.detach();
        }
        this.openDialog = false;
    }
}
/** @nocollapse */ DestinationDialogDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DestinationDialogDirective, deps: [{ token: i1$3.Overlay }, { token: i2.BreakpointObserver }, { token: DestinationDialogService }, { token: DOCUMENT, optional: true }], target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ DestinationDialogDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: DestinationDialogDirective, selector: "am-destination", inputs: { urlDna: "urlDna", origin: "origin", product: "product", positionRelativeTo: "positionRelativeTo" }, outputs: { destinationSelected: "destinationSelected" }, providers: [AM_DESTINATION_DIALOG_VALUE_ACCESSOR], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DestinationDialogDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: "am-destination",
                    providers: [AM_DESTINATION_DIALOG_VALUE_ACCESSOR]
                }]
        }], ctorParameters: function () { return [{ type: i1$3.Overlay }, { type: i2.BreakpointObserver }, { type: DestinationDialogService }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [DOCUMENT]
                }] }]; }, propDecorators: { urlDna: [{
                type: Input
            }], origin: [{
                type: Input
            }], product: [{
                type: Input
            }], positionRelativeTo: [{
                type: Input
            }], destinationSelected: [{
                type: Output
            }] } });

const width$1 = 120;
const height$1 = 119;
// tslint:disable-next-line
const path$1 = `M42.42.346c14.092 0 31.546 6.228 39.534 23.605.668 1.406 1.57 3.012 2.014 4.52.109.303 2.032 5.225 2.032 6.63v5.323c0 12.958-12.682 26.115-20.56 39.172-.775 1.308-2.47 2.713-3.358 4.118-1.332 2.11-2.876 4.32-4.206 6.53-4.88 7.534-9.857 15.369-14.852 23.102-8.1-11.85-16.275-23.706-24.154-35.758C11.546 66.34 1.74 54.385.185 43.136.077 42.232 0 40.424 0 40.223V35.4C2.774 11.797 23.553.346 42.42.346zm.581 13c-.606 0-1.143.417-1.333 1.034l-4.785 15.766h-15.48c-.607 0-1.146.42-1.334 1.039-.188.62.018 1.297.51 1.68L33.1 42.61l-4.782 15.766c-.189.62.017 1.3.509 1.683s1.16.383 1.651 0L43 50.313l12.522 9.744a1.33 1.33 0 0 0 1.65 0c.49-.381.697-1.06.51-1.678L52.9 42.61l12.521-9.745c.492-.383.698-1.06.51-1.68-.188-.62-.727-1.039-1.335-1.039H49.117L44.335 14.38c-.19-.617-.727-1.034-1.334-1.034z`;
const pinStar = {
    iconName: "pin-star",
    iconData: [
        height$1,
        width$1,
        path$1 // svgPathData
    ]
};

const width = 15;
const height = 15;
// tslint:disable-next-line
const path = `M9.682 2.487a5.094 5.094 0 0 0-7.195 0 5.094 5.094 0 0 0 0 7.195 5.094 5.094 0 0 0 6.499.576c.042.197.137.385.29.539l2.889 2.888a1.074 1.074 0 1 0 1.52-1.52l-2.889-2.889a1.075 1.075 0 0 0-.538-.29 5.092 5.092 0 0 0-.576-6.499zm-.619 6.576a4.186 4.186 0 0 1-5.913 0 4.187 4.187 0 0 1 0-5.912 4.187 4.187 0 0 1 5.913 0 4.185 4.185 0 0 1 0 5.912z`;
const search = {
    iconName: "search",
    iconData: [
        height,
        width,
        path // svgPathData
    ]
};

const ICON_NAMESPACE = 'DestinationDialog';
class DestinationDialogModule {
    constructor(iconRegistry) {
        this.iconRegistry = iconRegistry;
        iconRegistry.addSvgIconDefinitionInNamespace(pinStar, ICON_NAMESPACE);
        iconRegistry.addSvgIconDefinitionInNamespace(search, ICON_NAMESPACE);
    }
}
/** @nocollapse */ DestinationDialogModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DestinationDialogModule, deps: [{ token: i1$1.MbIconRegistry }], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ DestinationDialogModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: DestinationDialogModule, declarations: [DestinationDialogComponent, DestinationDialogDirective], imports: [OverlayModule,
        CommonModule,
        MbIconModule], exports: [DestinationDialogDirective] });
/** @nocollapse */ DestinationDialogModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DestinationDialogModule, providers: [DestinationDialogService], imports: [OverlayModule,
        CommonModule,
        MbIconModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: DestinationDialogModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DestinationDialogComponent, DestinationDialogDirective],
                    imports: [
                        OverlayModule,
                        CommonModule,
                        MbIconModule
                    ],
                    exports: [DestinationDialogDirective],
                    entryComponents: [DestinationDialogComponent],
                    providers: [DestinationDialogService]
                }]
        }], ctorParameters: function () { return [{ type: i1$1.MbIconRegistry }]; } });

/*
 * Public API Surface of destination-dialog
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AM_DESTINATION_DIALOG_VALUE_ACCESSOR, DestinationDialogComponent, DestinationDialogDirective, DestinationDialogModule, DestinationDialogService };
